import { Routes as Component } from 'features/common/components/Routes/Routes';

export const Routes = (): JSX.Element => <Component />;
